
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    singleShipmentLoadItemFromList: null,

    isTopPagesMapSideOpen: false

}

// export const getHomePageMapShipmentData = createAsyncThunk("topPagesMap/getHomePageMapShipmentData", async(_, thunkApi)=> {
//     try {
//         const {data} = await axiosInstance.get(`/ShipmentLocationHistories/GetAllLocations`)
//         return {
//             yuklemedeLocationList: data.yuklemedeLocations.$values,
//             seferdeLocationList: data.seferdeLocations.$values,
//             bosaltmadaLocationList: data.bosaltmadaLocations.$values
//         }
//     } catch (error) {
        
//         return thunkApi.rejectWithValue(error)
//     }
// })


const tpmSlice = createSlice({
    name: "tpm",
    initialState,
    reducers: {

        setSingleShipmentLoadItemFromList: (state,action) => {
            state.singleShipmentLoadItemFromList = action.payload
        },

        //! bu listelerde haritanın sağında veri kısmının gösterilmesini setleyen
        setIsTopPagesMapSideOpen: (state, action) => {
            state.isTopPagesMapSideOpen = action.payload
        },

        

     
        
        //! slice ı resetleyen
        resetAllState: () => initialState

    },
    extraReducers:(builder)=> {
        // builder

        // //! getHomePageMapShipmentData
        // .addCase(getHomePageMapShipmentData.pending, (state)=> {
        // })

        // .addCase(getHomePageMapShipmentData.fulfilled, (state, action)=> {
        //     state.homePageLocationData = {...state.homePageLocationData, ...action.payload}
        // })

        // .addCase(getHomePageMapShipmentData.rejected, (state, action)=> {
        // })

    }
})


export const {

    setSingleShipmentLoadItemFromList,

    setIsTopPagesMapSideOpen
} = tpmSlice.actions
export default tpmSlice.reducer